import React from 'react';
import { FiEdit2 } from 'react-icons/fi';
import Button from '../common/Button';
import { Card, CardHeader, CardTitle, CardContent } from '../common/Card';

const JDDetail = ({ jd, onEdit }) => {
  if (!jd) {
    return (
      <Card className="h-full flex items-center justify-center">
        <div className="text-center p-8 text-muted-foreground">
          请从左侧选择一个JD查看详情
        </div>
      </Card>
    );
  }

  return (
    <Card className="h-full">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-xl">{jd.title}</CardTitle>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onEdit(jd)}
          className="flex items-center gap-1"
        >
          <FiEdit2 className="h-4 w-4" />
          编辑
        </Button>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <div>
            <h3 className="text-sm font-medium text-muted-foreground mb-1">创建时间</h3>
            <p>{new Date(jd.created_at).toLocaleString()}</p>
          </div>
          
          <div>
            <h3 className="text-sm font-medium text-muted-foreground mb-1">更新时间</h3>
            <p>{new Date(jd.updated_at).toLocaleString()}</p>
          </div>
          
          <div>
            <h3 className="text-sm font-medium text-muted-foreground mb-1">职位描述</h3>
            <div className="p-4 rounded-md border bg-accent/20 whitespace-pre-wrap max-h-[calc(100vh-350px)] overflow-y-auto">
              {jd.content}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default JDDetail;
